import { CrownIcon } from '@/components/icons/CrownIcon';
import { cn } from '@/utils/cn';

export function TopPickPadge({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex w-full flex-row items-center justify-center rounded-lg bg-green-o50 px-3 py-1',
        className
      )}
    >
      <CrownIcon desc="Crown icon for top pick badge" title="Top Pick" />
      <p className="font-semibold text-xs">Top Pick</p>
    </div>
  );
}
